import Icon from '@ant-design/icons';
import '@ant-design/icons';
import React, { FC } from 'react';
import Wrap from './styles';

type Props = {
  title: string;
  icon: any;
};

const HeaderTitle: FC<Props> = ({ title, icon, children }) => {
  return (
    <Wrap>
      <div className="title">
        <Icon component={icon} className="icon1" />
        <p className="extraLargeFont inline">{title}</p>
      </div>
      {children}
    </Wrap>
  );
};

export default HeaderTitle;
